import type { SummonDefinition, SummonSite } from '../types';
import { MAIN_STAGE } from '../main-stage';
import { AMBYSS } from './ambyss';
import { DOME } from './dome';
import { PUMPUI } from './pumpui';

const REACH = 36;
const LOGS = 3;
const FIRE_RADIUS = 58;
const PILE_RADIUS = 40;
// Past the rim of the plates, drawn at 67/64 of the fire's radius, so no mask overlaps them.
const FIRE_BLOCK_RADIUS = 66;

// Placed clear of each stage's decor, and above a phone's action bar pinned bottom-right.
function campfire(
  setId: string,
  fire: { x: number; y: number },
  pile: { x: number; y: number },
): SummonDefinition {
  return {
    setId,
    look: 'fire',
    sources: [{ ...pile, radius: PILE_RADIUS, items: LOGS }],
    sites: [{ ...fire, radius: FIRE_RADIUS, capacity: LOGS, badVibeRadius: FIRE_BLOCK_RADIUS }],
    reach: REACH,
  };
}

const GATES = {
  top: { x: 800, y: 0 },
  right: { x: 1600, y: 500 },
  bottom: { x: 800, y: 1000 },
  left: { x: 0, y: 500 },
} as const;

function giant(x: number, y: number, gates: NonNullable<SummonSite['gates']>): SummonSite {
  return { x, y, radius: 60, capacity: 1, gates };
}

// Where src/render/full/giants.ts draws the glowing patches; one offering each wakes the four giants.
const SPORE_PATCH = { radius: 34, items: 1 };

const DOME_GIANTS: SummonDefinition = {
  setId: DOME.id,
  look: 'giants',
  sources: [
    { x: 322, y: 211, ...SPORE_PATCH },
    { x: 1278, y: 211, ...SPORE_PATCH },
    { x: 1278, y: 789, ...SPORE_PATCH },
    { x: 322, y: 789, ...SPORE_PATCH },
  ],
  sites: [
    giant(408, 108, [GATES.top, GATES.left]),
    giant(1192, 108, [GATES.top, GATES.right]),
    giant(1192, 892, [GATES.right, GATES.bottom]),
    giant(408, 892, [GATES.bottom, GATES.left]),
  ],
  reach: REACH,
};

export const FULL_SUMMONS: readonly SummonDefinition[] = [
  campfire(MAIN_STAGE.id, { x: 1100, y: 860 }, { x: 1390, y: 835 }),
  campfire(AMBYSS.id, { x: 1180, y: 790 }, { x: 1320, y: 830 }),
  campfire(PUMPUI.id, { x: 1190, y: 800 }, { x: 1420, y: 830 }),
  DOME_GIANTS,
];
